import Vue from 'vue'
export const clientPagiation = {
  namespaced: true,
  state: () => ({
    paginationClientsStateParams: {
      count: 0,
      limit: 100,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationClientsStateParams.total /
          state.paginationClientsStateParams.limit
      )
  },
  mutations: {
    update_pagination(state, { total, count, limit, page }) {
      state.paginationClientsStateParams = { total, count, limit, page }
    }
  },
  actions: {
    getClientsAll({ commit }, pagination) {
      commit('update_pagination', pagination)
    }
  }
}
